export const showIntercom = () => {
    window.Intercom?.('show')
}

export const shutdownIntercom = () => {
    window.Intercom?.('shutdown')
}
